import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  tabs: {
    height: "100%",
  },
  tabHistory: {
    height: "100%",
  },
  uiTab: {
    minHeight: "calc(100vh - 270px)",
    height: "100% !important",
  },
  containerGrid: {
    height: "calc(100vh - 200px)",
    [theme.breakpoints.down("sm")]: {
      height: "100%",
    },
  },
  titleStatusBadge: {
    height: "24px !important",
    width: "fit-content !important",
    fontFamily: "Manrope",
    marginRight: "8px",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "16px",
  },
  mainDiv: {
    padding: "15px 32px",
  },
  quickOrderLayout: {
    maxWidth: 1480,
    margin: "0 auto",
    paddingBottom: 96,
  },
  quickOrderPanel: {
    backgroundColor: "#FFFFFF",
    border: "1px solid #E4E7EC",
    borderRadius: 12,
    boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",
    marginBottom: 20,
    overflow: "hidden",
  },
  quickOrderPanelHeader: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "16px 20px",
    backgroundColor: "#F8FAFC",
    borderBottom: "1px solid #E4E7EC",
  },
  quickOrderStep: {
    alignItems: "center",
    backgroundColor: "#D9F7F4",
    borderRadius: 999,
    color: "#007F79",
    display: "inline-flex",
    fontFamily: "Manrope",
    fontSize: 13,
    fontWeight: 800,
    height: 28,
    justifyContent: "center",
    minWidth: 28,
  },
  quickOrderPanelTitle: {
    color: "#1D2939",
    fontFamily: "Manrope",
    fontSize: 20,
    fontWeight: 700,
    lineHeight: "28px",
    margin: 0,
  },
  quickOrderPanelBody: {
    padding: "20px",
  },
  quickOrderFooter: {
    position: "sticky",
    bottom: 0,
    zIndex: 10,
    backgroundColor: "rgba(255, 255, 255, 0.96)",
    border: "1px solid #E4E7EC",
    borderRadius: 12,
    boxShadow: "0 -8px 24px rgba(16, 24, 40, 0.08)",
    marginTop: 8,
    padding: "12px 16px",
    backdropFilter: "blur(8px)",
  },
  loading: {
    color: "#308CDB",
  },
}));

export default styles;
